import script from "./DataMilestones.vue?vue&type=script&setup=true&lang=js"
export * from "./DataMilestones.vue?vue&type=script&setup=true&lang=js"

import "./DataMilestones.vue?vue&type=style&index=0&id=efcd773a&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efcd773a"]])

export default __exports__